import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdAccountBalance, MdFavorite, MdInfo, MdVolunteerActivism } from "react-icons/md";
import bank from '../assets/bank_logo.png';

export default function DonationsContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);


  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready)
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div
      className="MainBodySection bg-background"
      style={{ paddingTop: "50px", paddingBottom: "50px" }}
    >
      
      <div className="container py-2">
      {/* Header Section */}
      <div className="text-center mb-4">
        <MdVolunteerActivism size={68} className="text-secondary" />
        <p className="text-muted mx-auto my-3" style={{ maxWidth: "700px", fontSize: "18px" }}>
          Are you passionate about positively impacting the lives of children in need? <br />
          Join us in supporting <strong>Tanzania Children Hope Innovations (TCHI)</strong>
        </p>
      </div>

      <div className="row justify-content-center mb-4">
        <div className="col-md-8">
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <MdAccountBalance size={40} className="me-2 text-primary" />
                <h4 className="mb-0 text-primary font-bold">CRDB BANK</h4>
              </div>

              <div className="row align-items-center">
                <div className="col-md-3 text-center mb-3 mb-md-0">
                  <div
                    className="bg-light border rounded p-3"
                    style={{
                      height: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden"
                    }}
                  >
                    <img 
                      src={bank}  
                      style={{
                         height: "100%"
                       }}
                    />
                  </div>
                </div>

                <div className="col-md-9">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <strong>Account Number:</strong> 0133812506700
                    </li>
                    <li>
                      <strong>Organization:</strong> Tanzania Children Hope Innovations
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <MdInfo size={32} className="me-2 text-primary" />
                <h5 className="mb-0 fw-semibold">How to Donate</h5>
              </div>

              <ol className="text-muted">
                <li className="mb-2">
                  Use the provided account number to make a direct bank transfer to CRDB.
                </li>
                <li className="mb-2">
                  Your donation will go directly to <strong>Tanzania Children Hope Innovations</strong> 
                  to fund their essential programs.
                </li>
              </ol>

              <p className="mt-3 text-primary text-center">
                <strong>Together, we can make a difference</strong> in the lives of these children. 
                Your support is their hope for a better tomorrow.
              </p>

              <p className="text-center mt-3 text-muted small">
                Thank you for your kindness and generosity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  );
}
